var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"DropdownMenuItem__root"},[_c('ButtonBehaviour',{staticClass:"DropdownMenuItem__link",attrs:{"href":_vm.href},on:_vm._d({},[_vm.clickEvent,_vm.onClick])},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }